import Rest from "../../../class/tool/Rest"
import StoreSetting from "./StoreSetting";
import FormBuilder from "../../../class/tool/FormBuilder";

class StoreSettingController {
    #_rest = new Rest();
    _callback = null;
    _baseURL = "stores/{idStore}/settings";
    static _storeRows = [
        {
            label: "Couleur principale (documents)",
            attribute: "color",
            inputType: "color",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "aucune",
            emptyText: "Aucun"
        },
        {
            label: "Horaires d'ouverture",
            attribute: "storeOpeningHours",
            inputType: "datetimeSlot",
            returnType: "json",
            classnameLabel: "label",
            classnameInput: ""
        },
    ];
    static _settingsRows = [
        {
            label: "Nombre de jours de validité d'un avoir",
            attribute: "assetValidity",
            inputType: "text",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "30",
            emptyText: "Aucun"
        },
        {
            label: "Désignation de la note sans détail",
            attribute: "paymentProofLabel",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "Repas",
            emptyText: "Aucun"
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Effet de flou",
            attribute: "blurEnabled",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Revenir sur la 1ère catégorie",
            attribute: "reinitCategoryAfterSale",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Sélection du tarif à chaque vente",
            attribute: "reinitPricelistAfterSale",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Revenir au tarif normal à chaque vente",
            attribute: "reinitDefaultPricelist",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Appliquer le tarif client au panier",
            attribute: "applyClientPricelistToExistingsContents",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Sélection du vendeur à chaque vente",
            attribute: "reinitSellerAfterSale",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Sélection simultanée d'un vendeur",
            attribute: "sellerInterupt",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Obliger la saisie d'un identifiant",
            attribute: "forceIdentifiant",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Activer la gestion des tables",
            attribute: "activeDiners",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Obliger la saisie du nombre de couverts",
            attribute: "forceDiners",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Afficher les notifications",
            attribute: "displayNotification",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Activer le son des touches",
            attribute: "keyPressSound",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Activer le son lors d'un encaissement",
            attribute: "saleSound",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Réglage automatique de la date (conseillé)",
            attribute: "automaticDatetimeControl",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            label: "Désélection automatique du vendeur",
            attribute: "sellerTimer",
            inputType: "select",
            returnType: "int",
            list: [
                {
                    "value": "Jamais",
                    "id": null
                },
                {
                    "value": "15 secondes",
                    "id": 15
                },
                {
                    "value": "30 secondes",
                    "id": 30
                },
                {
                    "value": "45 secondes",
                    "id": 45
                },
                {
                    "value": "60 secondes",
                    "id": 60
                }
            ],
            dictionary: null,
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Délais des notifications",
            attribute: "delayNotification",
            inputType: "select",
            returnType: "int",
            list: [
                {
                    "value": "3 secondes",
                    "id": 3
                },
                {
                    "value": "6 secondes",
                    "id": 6
                },
                {
                    "value": "9 secondes",
                    "id": 9
                },
                {
                    "value": "12 secondes",
                    "id": 12
                }
            ],
            dictionary: null,
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Clé API Zerosix",
            attribute: "zerosixApiKey",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "aucune",
            emptyText: "Aucun",
            readOnly: false,
            edit: false
        },
        {
            label: "Clé API Yavin",
            attribute: "yavinApiKey",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "aucune",
            emptyText: "Aucun",
            readOnly: false,
            edit: false
        },
        {
            label: "Clé API Otami",
            attribute: "otamiApiKey",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "aucune",
            emptyText: "Aucun",
            readOnly: false,
            edit: false
        }
    ];
    static _closingRows = [
        {
            label: "Heure d'ouverture d'une journée",
            attribute: "timeSlotBegin",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: null,
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune",
            readOnly: false,
            edit: false
        },
        {
            label: "Ne pas pouvoir clôturer la journée avant",
            attribute: "closingMinimalHour",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: null,
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Emails comptables (séparer par des virgules)",
            attribute: "accountantEmail",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "jean@dupont.fr, michel@dupont.fr",
            emptyText: "Aucun"
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Recevoir les clôtures journalières",
            attribute: "sendDailyClosingToAccountant",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Recevoir les clôtures mensuelles",
            attribute: "sendMonthlyClosingToAccountant",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Recevoir les clôtures annuelles",
            attribute: "sendYearlyClosingToAccountant",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        }
    ];
    static _billRows = [
        {
            label: "Obliger un acompte sur les commandes",
            attribute: "requireDepositPurchaseOrder",
            inputType: "select",
            returnType: "string",
            list: [
                {
                    "value": "NONE",
                    "id": 0
                },
                {
                    "value": "ALL",
                    "id": 1
                },
                {
                    "value": "B2B",
                    "id": 2
                },
                {
                    "value": "B2C",
                    "id": 3
                }
            ],
            dictionary: {
                "NONE": "Non",
                "ALL": "Toujours",
                "B2B": "Pour les professionnels uniquement",
                "B2C": "Pour les particuliers uniquement"
            },
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune",
            readOnly: false,
            edit: false
        },
        {
            label: "Règle d'acompte minumum",
            attribute: "typeDepositPurchaseOrder",
            inputType: "select",
            returnType: "string",
            list: [
                {
                    "value": "none",
                    "id": 0
                },
                {
                    "value": "devise",
                    "id": 1
                },
                {
                    "value": "percent",
                    "id": 2
                }
            ],
            dictionary: {
                "none": "Aucune",
                "devise": "Montant minimum (€)",
                "percent": "Pourcentage minimum (%)"
            },
            classnameLabel: "label",
            classnameInput: "typeDepositPurchaseOrder",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune",
            readOnly: false,
            edit: false
        },
        {
            label: "Montant de la règle d'acompte minimum",
            attribute: "valueDepositPurchaseOrder",
            inputType: "text",
            returnType: "float",
            classnameLabel: "label",
            classnameInput: "valueDepositPurchaseOrder",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "IBAN",
            attribute: "iban",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "aucun",
            emptyText: "Aucun"
        },
        {
            label: "Conditions générales de vente",
            attribute: "billGeneralConditions",
            inputType: "textarea",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "aucune",
            emptyText: "Aucune"
        }
    ];
    static _receiptRows = [
        {
            noLabel: true,
            label: "",
            subLabel: "Imprimer la note lors de la mise en attente",
            attribute: "automaticNotePrinting",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Imprimer le code barre sur la vente",
            attribute: "saleBarcode",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Imprimer le code barre sur la note",
            attribute: "kartBarcode",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Imprimer le code barre sur l'avoir",
            attribute: "assetBarcode",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Imprimer le détails vendeurs",
            attribute: "sellerDetailsPrinting",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Imprimer le détails catégories",
            attribute: "categoryDetailsPrinting",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Imprimer le détails produits",
            attribute: "productDetailsPrinting",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        },
        {
            noLabel: true,
            label: "",
            subLabel: "Imprimer le détails des règlements",
            attribute: "printPaymentsDetailUnit",
            inputType: "switch",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: ""
        }
    ];
    static _notificationRows = [
        {
            label: "Tentatives d'accès (3 erreurs de mot de passe)",
            attribute: "notifyPwdTracker",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Approvisionnement monnayeur",
            attribute: "notifyCashIn",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Prélèvement monnayeur",
            attribute: "notifyCashOut",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Cassette vide",
            attribute: "notifyDrawerEmptyCollection",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Cassette presque vide",
            attribute: "notifyDrawerLowCollection",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Cassette presque pleine",
            attribute: "notifyDrawerHighCollection",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Cassette peine",
            attribute: "notifyDrawerFullCollection",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Monnaie vide",
            attribute: "notifyDrawerEmptyDevice",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Monnaie presque vide",
            attribute: "notifyDrawerLowDevice",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Monnaie presque pleine",
            attribute: "notifyDrawerHighDevice",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Monnaie pleine",
            attribute: "notifyDrawerFullDevice",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Remplacement de cassette pièces",
            attribute: "notifyReplaceCoinCassette",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Remplacement de cassette billets",
            attribute: "notifyReplaceCashCassette",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Alerte seuil total monnayeur",
            attribute: "notifyDrawerThreshold",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Montant du seuil",
            attribute: "drawerThreshold",
            inputType: "text",
            returnType: "int",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "0",
            emptyText: "Aucun"
        },
        {
            label: "Erreur du monnayeur",
            attribute: "notifyDrawerIssue",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        },
        {
            label: "Réinitialisation du monnayeur",
            attribute: "notifyRebootDrawer",
            inputType: "select",
            returnType: "int",
            list: [],
            dictionary: {},
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucune"
        }
    ];
    static _prefixRows = [{
        label: "Préfixes des codes barres EAN 13 générés",
        attribute: "barcodePrefixes",
        inputType: "barcodePrefixes",
        returnType: "json",
        classnameLabel: "label",
        classnameInput: "marginTop"
    }];

    static checkTimeSlotBegin(val) {
        return true;
    }
    static getRows(type) {
        const user = JSON.parse(localStorage.getItem("user"));
        let rows = [];
        let index = -1;
        let attributes = [];

        switch (type) {
            case "store":
                rows = StoreSettingController._storeRows;
                break;
            case "settings":
                rows = StoreSettingController._settingsRows;
                attributes = ["zerosixApiKey", "yavinApiKey", "otamiApiKey"];

                for (let i in attributes) {
                    index = rows.findIndex(_ => _.attribute === attributes[i]);

                    if (index >= 0) {
                        rows[index].readOnly = user.onlyHivy !== 1;
                        rows[index].edit = user.onlyHivy === 1;
                    }
                }

                break;
            case "closing":
                rows = StoreSettingController._closingRows;
                attributes = ["timeSlotBegin"];
                let openingHours = []
                let closingLimitHours = [{ value: "Aucune contrainte", id: null }]

                for (let i in attributes) {
                    index = rows.findIndex(_ => _.attribute === attributes[i]);

                    if (index >= 0) {
                        rows[index].readOnly = user.onlyHivy !== 1;
                        rows[index].edit = user.onlyHivy === 1;
                    }
                }

                for (let i = 0; i <= 9; i++) {
                    openingHours.push({
                        value: "0" + i + "h",
                        id: i
                    });
                }

                for (let i = 15; i <= 23; i++) {
                    closingLimitHours.push({
                        value: i + "h",
                        id: i
                    });
                }

                rows[0].list = openingHours;
                rows[1].list = closingLimitHours;

                break;
            case "bill":
                rows = StoreSettingController._billRows;
                break;
            case "receipt":
                rows = StoreSettingController._receiptRows;
                break;
            case "notification":
                const notifValues = [
                    {
                        value: 0,
                        id: 0
                    },
                    {
                        value: 1,
                        id: 1
                    },
                    {
                        value: 2,
                        id: 2
                    },
                    {
                        value: 3,
                        id: 3
                    }
                ];
                const dictNotifValues = {
                    0: "Aucune",
                    1: "Email",
                    2: "Notification",
                    3: "Email et notification"
                }
                rows = StoreSettingController._notificationRows;
                attributes = [
                    "notifyRebootDrawer",
                    "notifyDrawerIssue",
                    "notifyDrawerThreshold",
                    "notifyReplaceCashCassette",
                    "notifyReplaceCoinCassette",
                    "notifyDrawerFullDevice",
                    "notifyDrawerHighDevice",
                    "notifyDrawerLowDevice",
                    "notifyDrawerEmptyDevice",
                    "notifyDrawerFullCollection",
                    "notifyDrawerHighCollection",
                    "notifyDrawerLowCollection",
                    "notifyDrawerEmptyCollection",
                    "notifyCashOut",
                    "notifyCashIn",
                    "notifyPwdTracker"
                ];

                for (let i in attributes) {
                    index = rows.findIndex(_ => _.attribute === attributes[i]);

                    if (index >= 0) {
                        rows[index].list = notifValues;
                        rows[index].dictionary = dictNotifValues;
                    }
                }

                break;
            case "prefix":
                rows = StoreSettingController._prefixRows;
                break;
            default: break;
        }

        return rows;
    }

    setFormValues(store, object, setValues) {
        setValues(prev => ({
            ...prev,
            timeSlotBegin: object.timeSlotBegin,
            closingMinimalHour: object.closingMinimalHour,
            assetValidity: object.assetValidity,
            blurEnabled: object.blurEnabled,
            reinitCategoryAfterSale: object.reinitCategoryAfterSale,
            reinitSellerAfterSale: object.reinitSellerAfterSale,
            reinitSellerAfterProduct: object.reinitSellerAfterProduct,
            reinitPricelistAfterSale: object.reinitPricelistAfterSale,
            reinitDefaultPricelist: object.reinitDefaultPricelist,
            applyClientPricelistToExistingsContents: object.applyClientPricelistToExistingsContents,
            reinitPricelistAfterProduct: object.reinitPricelistAfterProduct,
            kartPrefix: object.kartPrefix,
            paymentProofLabel: object.paymentProofLabel,
            saleBarcode: object.saleBarcode,
            kartBarcode: object.kartBarcode,
            assetBarcode: object.assetBarcode,
            receiptHeader: JSON.parse(object.receiptHeader),
            receiptFooter: JSON.parse(object.receiptFooter),
            autoBarcodeSellers: object.autoBarcodeSellers,
            barcodePrefixes: JSON.parse(object.barcodePrefixes),
            theme: object.theme,
            fiscalYearMonth: object.fiscalYearMonth,
            accumulateQuantities: object.accumulateQuantities,
            accountantEmail: object.accountantEmail,
            sellerDetailsPrinting: object.sellerDetailsPrinting,
            categoryDetailsPrinting: object.categoryDetailsPrinting,
            productDetailsPrinting: object.productDetailsPrinting,
            printPaymentsDetailUnit: object.printPaymentsDetailUnit,
            forceIdentifiant: object.forceIdentifiant,
            activeDiners: object.activeDiners,
            forceDiners: object.forceDiners,
            timezone: object.timezone,
            keyPressSound: object.keyPressSound,
            saleSound: object.saleSound,
            displayNotification: object.displayNotification,
            delayNotification: object.delayNotification,
            automaticDatetimeControl: object.automaticDatetimeControl,
            automaticNotePrinting: object.automaticNotePrinting,
            sellerInterupt: object.sellerInterupt,
            sellerTimer: object.sellerTimer,
            zerosixApiKey: object.zerosixApiKey,
            yavinApiKey: object.yavinApiKey,
            otamiApiKey: object.otamiApiKey,
            color: object.color,
            logo: object.logo,
            iban: object.iban,
            notifyPwdTracker: object.notifyPwdTracker,
            notifyCashIn: object.notifyCashIn,
            notifyCashOut: object.notifyCashOut,
            notifyDrawerEmptyCollection: object.notifyDrawerEmptyCollection,
            notifyDrawerLowCollection: object.notifyDrawerLowCollection,
            notifyDrawerHighCollection: object.notifyDrawerHighCollection,
            notifyDrawerFullCollection: object.notifyDrawerFullCollection,
            notifyDrawerEmptyDevice: object.notifyDrawerEmptyDevice,
            notifyDrawerLowDevice: object.notifyDrawerLowDevice,
            notifyDrawerHighDevice: object.notifyDrawerHighDevice,
            notifyDrawerFullDevice: object.notifyDrawerFullDevice,
            notifyDrawerIssue: object.notifyDrawerIssue,
            notifyRebootDrawer: object.notifyRebootDrawer,
            notifyReplaceCashCassette: object.notifyReplaceCashCassette,
            notifyReplaceCoinCassette: object.notifyReplaceCoinCassette,
            drawerThreshold: object.drawerThreshold,
            notifyDrawerThreshold: object.notifyDrawerThreshold,
            sendDailyClosingToAccountant: object.sendDailyClosingToAccountant,
            sendMonthlyClosingToAccountant: object.sendMonthlyClosingToAccountant,
            sendYearlyClosingToAccountant: object.sendYearlyClosingToAccountant
        }));
    }
    returnUpdatesFromCompare(object, datas, compare = true) {
        // clean header & footer receipt
        if (datas.receiptHeader !== undefined) {
            if (typeof datas.receiptHeader !== "object")
                datas.receiptHeader = JSON.parse(datas.receiptHeader)

            let header = []

            for (let i = 0; i < datas.receiptHeader.length; i++) {
                if (datas.receiptHeader[i].text !== "") {
                    header.push(datas.receiptHeader[i])
                }
            }

            datas.receiptHeader = header
        }
        if (datas.receiptFooter !== undefined) {
            if (typeof datas.receiptFooter !== "object")
                datas.receiptFooter = JSON.parse(datas.receiptFooter)

            let footer = []

            for (let i = 0; i < datas.receiptFooter.length; i++) {
                if (datas.receiptFooter[i].text !== "") {
                    footer.push(datas.receiptFooter[i])
                }
            }

            datas.receiptFooter = footer
        }
        if (datas.barcodePrefixes !== undefined) {
            if (typeof datas.barcodePrefixes !== "object")
                datas.barcodePrefixes = JSON.parse(datas.barcodePrefixes)

            let prefixes = {}

            for (let key in datas.barcodePrefixes) {
                if (datas.barcodePrefixes[key].length > 0) {
                    prefixes[key] = datas.barcodePrefixes[key]
                }
            }

            datas.barcodePrefixes = prefixes
        }

        let obj = Object.assign({}, object)
        obj.receiptHeader = JSON.parse(object.receiptHeader)
        obj.receiptFooter = JSON.parse(object.receiptFooter)
        obj.barcodePrefixes = JSON.parse(object.barcodePrefixes)

        return FormBuilder.returnUpdates(obj, datas, compare)
    }
    checkValues(object) {
        const params = [
            { name: "name", method: "checkName", val: object.name },
            { name: "label", method: "checkLabel", val: object.label },
            { name: "color", method: "checkColor", val: object.color },
            { name: "reference", method: "checkReference", val: object.reference },
            { name: "referenceProvider", method: "checkReferenceProvider", val: object.referenceProvider },
            { name: "provider", method: "checkProvider", val: object.provider_id },
            { name: "brand", method: "checkBrand", val: object.brand_id },
            { name: "category", method: "checkCategory", val: { id: object.category_id, type: object.category_type } },
            { name: "description", method: "checkDescription", val: object.description },
            { name: "nullStockTrigger", method: "checkNullStockTrigger", val: object.nullStockTrigger },
            { name: "printDescription", method: "checkPrintDescription", val: object.printDescription },
            { name: "soldOut", method: "checkSoldOut", val: object.soldOut },
            { name: "stockManagement", method: "checkStockManagement", val: object.stockManagement },
            { name: "stockThresholdTrigger", method: "checkStockThresholdTrigger", val: object.stockThresholdTrigger },
            { name: "unit", method: "checkUnit", val: object.unit },
            { name: "variablePrice", method: "checkVariablePrice", val: object.variablePrice }
        ];
        let errors = {};
        let method;

        for (let i in params) {
            method = StoreSettingController[params[i].method];

            try { method.apply(null, params[i].val); }
            catch (e) { errors.params[i].name = e.message; }
        }

        if (Object.keys(errors).length > 0) throw new Error(JSON.stringify(errors));
        else return true;
    }

    show(id) {
        this.#_rest.sendQuery(
            'GET',
            '/' + this._baseURL.replace("{idStore}", id),
            {},
            this.handleShow);
    }
    handleShow = (response, error, status = 200) => {
        const object = !error ? new StoreSetting(response.data) : null;
        this._callback(object, error, status);
    }

    put(object, datas) {
        this.#_rest.sendQuery(
            'PUT',
            '/' + this._baseURL.replace("{idStore}", object.store_id),
            datas,
            this.handlePut);
    }
    handlePut = (response, error, status) => {
        this._callback(response, error, status);
    }

    delete(object) {
        this.#_rest.sendQuery(
            'DELETE',
            '/' + this._baseURL.replace("{idStore}", object.store_id),
            {},
            this.handleDelete);
    }
    handleDelete = (response, error, status) => {
        this._callback(response, error, status);
    }

    histoTarget(id) {
        this.#_rest.sendQuery(
            'GET',
            '/' + this._baseURL.replace("{idStore}", id) + '/histos',
            {},
            this.handleHistoTarget);
    }
    handleHistoTarget = (response, error, status = 200) => {
        let listObjects = [];

        if(status === 200) {
            let data = response.data;

            for(var item in data)
                listObjects.push(data[item]);
        }

        this._callback(listObjects, error, status);
    }
}

export default StoreSettingController;